// import Vue from 'vue'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

import App from './App'
import router from './router'
import store from './store'

// 通用指令过滤器 指令
import './lvya-common/src/service/directive/index'
// 通用工具类

// api统一成全局 访问
// import ApiAdmin from './edu-common/src/api/admin/index'
// window.ApiAdmin = ApiAdmin

// 导入flex布局
// import './edu-common/src/css/flex.css'

import Cookies from 'js-cookie'
// 配置成全局使用
window.Cookies = Cookies

// 导入微应用
import { initMicro } from './MicroSetting'
initMicro(router, store)

// Vue.use(ElementUI)
// VueInstance可以全局使用
window.VueInstance = new Vue({
  el: '#microContainer',
  router,
  store,
  render: h => h(App)
})
